import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
export default {
  name: 'pbl_s',
  data() {
    return {
      list: [],
      singleform: {
        limit: 100,
        page: 1
      },
      screenName: '',
      columnForm: {
        limit: 100,
        page: 1
      },
      detailList: [],
      t_url: {}
    };
  },
  methods: {
    // 获取页面配置
    getConfig() {
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.formId = 215424;
      this.singleform.formUserId = this.$route.query.formUserId;
      this.$api.getListByUserId(this.singleform).then(res => {
        if (!res.formUserList || !res.formUserList.length) return;
        this.screenName = res.formUserList[0].formData.find(item => {
          return item.id == 3;
        }) ? res.formUserList[0].formData.find(item => {
          return item.id == 3;
        }).values[0].val : '';
        this.config = {
          formId_a: 112720,
          formId_3d: 113010,
          formId_column: 112712
        };
        this.getsingleformList();
      });
    },
    // 获取文物列表
    getsingleformList() {
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = this.config.formId_3d;
      this.$api.singleformList(this.singleform).then(res => {
        this.setData(res.data);
      });
    },
    setData(data) {
      data = data.map((item, index) => {
        let nItem = {
          columnName: this.getValInFormData(item.formData, 'column'),
          name: this.getValInFormData(item.formData, 'antiqueName'),
          img: this.getValInFormData(item.formData, 'thumbnail', 'objectId', 'suffix'),
          code: this.getValInFormData(item.formData, 'autoId'),
          type: this.getValInFormData(item.formData, 'type'),
          touchType: this.getValInFormDataList(item.formData, 'touchType'),
          code: this.getValInFormData(item.formData, 'autoId'),
          // images_360: this.getValInFormDataList(item.formData, 'panorama', 'objectId', 'suffix'),
          images: this.getValInFormDataList(item.formData, 'image', 'objectId', 'suffix'),
          images_360: this.getValInFormDataList(item.formData, 'panorama', 'name')
        };
        let data_3d = item.formData.find(f => {
          return f.alias == 15;
        }).formDataList;
        if (data_3d) {
          nItem.attribute3d = {
            zoomRatio: this.getValInFormData(item.formData, 'zoom', ''),
            pointLight: this.getValInFormData(item.formData, 'pointLight', ''),
            pointColor: this.getValInFormData(item.formData, 'pointLightColor', ''),
            highlight: this.getValInFormData(item.formData, 'highLight', ''),
            envLight: this.getValInFormData(item.formData, 'environmentLight', ''),
            envColor: this.getValInFormData(item.formData, 'environmentColor', ''),
            parallelLight: this.getValInFormData(item.formData, 'parallelLight', ''),
            modelCenter: this.getValInFormData(item.formData, 'modelCenter', '')
          };
          nItem.attributeModels = data_3d.map((d, index) => {
            let target = {
              angleX: parseFloat(this.getValInFormData(d, 'angleX', '')),
              angleY: parseFloat(this.getValInFormData(d, 'angleY', '')),
              angleZ: parseFloat(this.getValInFormData(d, 'angleZ', '')),
              axisX: parseFloat(this.getValInFormData(d, 'axisX', '')),
              axisY: parseFloat(this.getValInFormData(d, 'axisY', '')),
              axisZ: parseFloat(this.getValInFormData(d, 'axisZ', '')),
              modelName: this.getValInFormData(d, 25, 'objectId'),
              mtlName: this.getValInFormData(d, 23, 'objectId'),
              normalPath: this.getValInFormData(d, 26, 'objectId', 'suffix'),
              chartlet: this.getValInFormData(d, 24, 'objectId', 'suffix'),
              modelPath: this.getValInFormData(d, 23, 'objectId', 'suffix')
            };
            this.t_url[this.getValInFormData(d, 23, 'name')] = target.mtlName;
            this.t_url[this.getValInFormData(d, 25, 'name')] = target.modelName;
            this.t_url[this.getValInFormData(d, 24, 'name')] = target.chartlet;
            return target;
          });
        }
        return nItem;
      });
      if (!this.$route.query.allData) {
        data = data.filter(item => {
          return item.touchType.indexOf(this.screenName) > -1;
        });
      }
      this.list = data.concat(data);
      this.getDetailList();
    },
    getValInFormData(data, id, type, type2) {
      let target = data.find(d => {
        return d.alias == id;
      }).values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_IMG_URL + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      if (type2) return `${target[type]}.${target[type2]}`;
      return type ? target[type] : target.val;
    },
    getValInFormDataFiles(data, id, type) {
      let targets = [];
      data.map(item => {
        let target = item.find(d => {
          return d.alias == id;
        });
        if (!target || !target.values[0]) return;
        target = target.values[0][type];
        targets.push(target);
      });
      return targets;
    },
    getValInFormDataList(data, id, type, type2) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values.map(item => {
        if (type2) return `${item[type]}.${item[type2]}`;
        return type ? item[type] : item.val;
      });
      return type ? target : target.join(',');
    },
    getDetailList() {
      this.columnForm.fid = this.$route.query.fid || '151066';
      this.columnForm.formId = 112720;
      this.$api.singleformList(this.columnForm).then(res => {
        res.data.map(item => {
          let data = {
            description: this.getValInFormData(item.formData, 'description'),
            audio: this.getValInFormData(item.formData, 'audio', 'objectId'),
            code: this.getValInFormDataList(item.formData, 'autoId')
          };
          this.detailList.push(data);
        });
        this.setJson();
      });
    },
    setJson() {
      let datas = this.list.map(item => {
        let target = this.detailList.find(d => {
          return d.code == item.code;
        });
        if (target) {
          item.description = target.description;
          item.audio = target.audio;
          item.fid = this.$route.query.fid;
        }
        return item;
      });
      var content = JSON.stringify({
        data: datas,
        t_url: this.t_url
      });
      var blob = new Blob([content], {
        type: "text/plain;charset=utf-8"
      });
      saveAs(blob, "data.json");
    }
  },
  created() {
    this.getConfig();
    let list1 = ['FileSaver.js'];
    list1.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/${item}`;
      document.body.appendChild(oScript);
    });
  },
  computed: {}
};